import { useSelector } from "react-redux";

import { Buttons, tables, inputFields } from "../../components";

const Programs = ({ state, setState, setActiveTab }) => {
  const { programTypes } = useSelector((state) => state?.others);

  const programTypesFiltered = programTypes?.map((programType) => ({
    label: programType?.programType,
    value: programType?.id,
  }));

  const handleProgramChange = (index, field, value) => {
    const updatedPrograms = [...state.programs];
    updatedPrograms[index][field] = value;
    setState({ ...state, programs: updatedPrograms });
  };

  const addProgram = () => {
    const newProgram = {
      programme: null,
      courseLink: null,
      programLink: null,
      programName: null,
      duration: null,
      tuitionFee: null,
      tuitionFeeInternational: null,
      programTypeId: null,
    };
    setState({ ...state, programs: [...state.programs, newProgram] });
  };

  const removeProgram = (index) => {
    const updatedPrograms = state.programs.filter((_, i) => i !== index);
    setState({ ...state, programs: updatedPrograms });
  };

  const columns = [
    {
      title: "#",
      dataIndex: "#",
      width: 40,
      render: (text, record, index) => index + 1,
    },
    {
      title: "Programme",
      dataIndex: "programme",
      width: 100,
      render: (text, record, index) => (
        <inputFields.DefaultInput
          value={text}
          onChange={(e) =>
            handleProgramChange(index, "programme", e.target.value)
          }
        />
      ),
    },
    {
      title: "Course Link",
      dataIndex: "courseLink",
      width: 150,
      render: (text, record, index) => (
        <inputFields.DefaultInput
          value={text}
          onChange={(e) =>
            handleProgramChange(index, "courseLink", e.target.value)
          }
        />
      ),
    },
    {
      title: "Program Link",
      dataIndex: "programLink",
      width: 400,
      render: (text, record, index) => (
        <inputFields.DefaultInput
          value={text}
          onChange={(e) =>
            handleProgramChange(index, "programLink", e.target.value)
          }
        />
      ),
    },
    {
      title: "Program Name",
      dataIndex: "programName",
      width: 220,
      render: (text, record, index) => (
        <inputFields.DefaultInput
          value={text}
          onChange={(e) =>
            handleProgramChange(index, "programName", e.target.value)
          }
        />
      ),
    },
    {
      title: "Duration",
      dataIndex: "duration",
      width: 100,
      render: (text, record, index) => (
        <inputFields.DefaultInput
          value={text}
          onChange={(e) =>
            handleProgramChange(index, "duration", e.target.value)
          }
        />
      ),
    },
    {
      title: "Tuition Fee",
      dataIndex: "tuitionFee",
      width: 150,
      render: (text, record, index) => (
        <inputFields.DefaultInput
          value={text}
          onChange={(e) =>
            handleProgramChange(index, "tuitionFee", e.target.value)
          }
        />
      ),
    },
    {
      title: "Tuition Fee (International)",
      dataIndex: "tuitionFeeInternational",
      width: 100,
      render: (text, record, index) => (
        <inputFields.DefaultInput
          value={text}
          onChange={(e) =>
            handleProgramChange(
              index,
              "tuitionFeeInternational",
              e.target.value
            )
          }
        />
      ),
    },
    {
      title: "Program Type",
      dataIndex: "programTypeId",
      width: 100,
      render: (text, record, index) => (
        <div className="w-[12em]">
          <inputFields.SelectDropdown
            value={text}
            onChange={(value) =>
              handleProgramChange(index, "programTypeId", value)
            }
            items={programTypesFiltered}
          />
        </div>
      ),
    },
    {
      title: "Actions",
      width: 80,
      render: (_, record, index) => (
        <div>
          <Buttons.RedButton size="medium" onClick={() => removeProgram(index)}>
            Remove
          </Buttons.RedButton>
        </div>
      ),
    },
  ];

  return (
    <div className="flex flex-col gap-6">
      <div className="w-[calc(100vw-20em)] overflow-x-auto max-w-full relative">
        <tables.DefaultTable
          dataSource={state.programs}
          columns={columns}
          rowKey={(record, index) => index}
          pagination={false}
        />
      </div>
      <div className="flex gap-5 justify-end">
        <Buttons.DefaultButton size="medium" onClick={addProgram}>
          Add Program
        </Buttons.DefaultButton>

        <Buttons.DefaultButton size="medium" onClick={() => setActiveTab("3")}>
          Next
        </Buttons.DefaultButton>
      </div>
    </div>
  );
};

export default Programs;
